<template>
  <v-app>
    <!-- <Auth /> -->
    <v-navigation-drawer
      v-if="isLoggedIn"
      v-model="drawer"
      app
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title primary--text text-center">
            <v-img :src="logo" contain :height="32" alt="logo" class="mb-5" />
            Suidlanders
          </v-list-item-title>
          <v-list-item-subtitle>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider />
      <div class="p-5">
        <OrganizationSelect v-if="hasMultipleOrgs" />
      </div>
      <v-divider />
      <MenuDrawer />
      <v-divider />
      <AdminMenuDrawer
        v-if="isInRole('Administrators') || isInRole('Area Admins') || isInRole('Kliente Bestuur')"
      />
      <v-spacer></v-spacer>
    </v-navigation-drawer>

    <v-app-bar app>
      <v-app-bar-nav-icon @click="drawer = !drawer" v-if="isLoggedIn" />
      <v-toolbar-title class="hidden-sm-and-down">
        <span class="primary--text mt-2">
          Suidlanders
        </span>
      </v-toolbar-title>
      <div class="ml-2 hidden-sm-and-down">
        <OrganizationMenu v-if="hasMultipleOrgs && !isExpired" />
      </div>
      <v-spacer></v-spacer>
      <ReadinessDisplay v-if="isLoggedIn" />
      <v-spacer></v-spacer>
      <PushNotifications v-if="isLoggedIn && platform === 'web' && !isExpired" class="mr-3" />
      <AndroidPushNotifications v-if="isLoggedIn && platform === 'android' && !isExpired"
        class="mr-3" />
      <Location v-if="isLoggedIn" class="mr-3" />
      <!-- <LocaleSwitcher /> -->
      <!-- <div class="ml-2 hidden-sm-and-down">
        <Account />
      </div> -->
      <settings-menu />
    </v-app-bar>

    <v-main>
      <keep-alive :include="[]">
        <router-view></router-view>
      </keep-alive>
      <!--  -->
    </v-main>

    <v-footer padless>
      <v-col
        class="text-center"
        cols="12"
      >
        <!-- Copyright &copy; {{ new Date().getFullYear() }} <strong>Suidlanders</strong> -->
        <v-btn small color="primary" href="tel:+27741316363">
          <v-icon class="mr-2">{{ mdiPhoneDial }}</v-icon>
          {{ $t('common.callCenter') }}
        </v-btn>
        <v-spacer></v-spacer>
        v{{ appVersion }}
      </v-col>
    </v-footer>

    <Toasts :text="message" color="success" />
    <Toasts :text="error" color="error" />
    <BasicToasts />
    <ServiceWorkerUpdate />
  </v-app>
</template>

<script>
import { components as auroraAppCore, authHub, errorHub } from '@codehq/aurora-app-core/src';
import axios from 'axios';
import org from '@codehq/aurora-app-core/src/mixins/org';
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import { Capacitor } from '@capacitor/core';
import { mdiPhoneDial } from '@mdi/js';
import Location from './modules/membership/src/components/Location.vue';
import ReadinessDisplay from './modules/membership/src/components/ReadinessDisplay.vue';
import MenuDrawer from './components/MenuDrawer.vue';
import AndroidPushNotifications from './components/AndroidPushNotifications.vue';
import AdminMenuDrawer from './components/AdminMenuDrawer.vue';
import ServiceWorkerUpdate from './components/ServiceWorkerUpdate.vue';
import SettingsMenu from './components/SettingsMenu.vue';
import appColours from './appColours';
// import auth from './auth';

const {
  BasicToasts, Toasts, OrganizationMenu, OrganizationSelect, PushNotifications,
} = auroraAppCore;

export default {
  name: 'App',
  components: {
    AdminMenuDrawer,
    AndroidPushNotifications,
    BasicToasts,
    Location,
    MenuDrawer,
    OrganizationMenu,
    OrganizationSelect,
    ReadinessDisplay,
    PushNotifications,
    Toasts,
    ServiceWorkerUpdate,
    SettingsMenu,
  },
  mixins: [appColours, org],
  data() {
    return {
      mdiPhoneDial,
      message: '',
      error: '',
      drawer: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'isInRole', 'isExpired']),
    ...mapGetters('organizations', ['hasMultipleOrgs']),
    ...mapState('organizations', ['organization', 'organizations']),
    ...mapState('auth', ['token']),
    appVersion() {
      return process.env.PACKAGE_VERSION?.version ?? '0';
    },
    isAreaAdmins() {
      return this.isInRole('Area Admins');
    },
    isProduction() {
      return process.env.NODE_ENV.trim() !== 'development';
    },
    logo() {
      switch (this.organization?.id) {
        default:
        case 1:
          // eslint-disable-next-line global-require
          return require('./assets/logo.jpg');
        case 2:
          // eslint-disable-next-line global-require
          return require('./assets/verdediging-logo.png');
      }
    },
    platform() {
      return Capacitor.getPlatform();
    },
  },
  watch: {
    organization() {
      this.setColours(this.organization);
    },
  },
  async created() {
    this.$log.debug('app created loaded');
    this.setupAxios();
    this.$root.$on('auth:login', async () => {
      await this.$nextTick();
      this.setupAxios();
      await this.LOAD_organizations();
      this.$log.info(this.organizations);
      if (this.organizations.length === 1) {
        this.SET_organization(this.organizations[0]);
        this.setColours(this.organizations[0]);
      } else {
        this.setColours(this.organization);
      }
    });
    errorHub.$on('network.error', () => {
      this.$root.$emit('network.error');
    });
    this.$root.$on('notify.error', (err) => {
      this.error = '';
      this.error = err;
    });
    authHub.$on('user.unauthorized', () => {
      this.LOGOUT_auth();
      this.$router.push('/auth/login');
    });
    this.$root.$on('auth:login', () => {
      this.$router.push('/home');
      this.$root.$emit('toast:notify', 'Logged in successfully');
      this.setColours(this.organization);
    });
    this.$root.$on('auth:logoff', () => {
      this.LOGOUT_auth();
      this.$router.push('/auth/login');
    });
    this.$root.$on('organization.changed', () => {
      this.setColours(this.organization);
    });
    this.$root.$on('App.appStateChange', async (o) => {
      if (o) {
        await this.REFRESH_auth();
      }
    });
    this.setColours(this.organization);
  },
  mounted() {
    this.setColours(this.organization);
  },
  destroyed() {
    authHub.$off('user.unauthorized');
    this.$root.$off('auth:login');
  },
  methods: {
    ...mapActions('auth', ['INIT_auth', 'LOGOUT_auth', 'REFRESH_auth']),
    ...mapActions('organizations', ['LOAD_organizations']),
    ...mapMutations('organizations', ['SET_organization']),
    async accept() {
      // this.showUpgradeUI = false;
      await this.$workbox.messageSW({ type: 'SKIP_WAITING' });
    },
    logout() {
      this.LOGOUT_auth();
      this.$router.push('/auth/login');
    },
    refresh() {
      this.setColours(this.organization);
    },
    setupAxios() {
      this.$log.debug('setting up axios');
      axios.interceptors.request.use((config) => {
        // eslint-disable-next-line no-param-reassign
        config.headers.common.Authorization = `Bearer ${this.token}`;
        return config;
      }, (error) => Promise.reject(error));
      axios.interceptors.response.use((response) => response, (error) => {
        this.$log.error(error);
        if (error.response.status === 401) {
          this.$root.$emit('user.unauthorized');
        }
        return Promise.reject(error);
      });
      this.$log.debug('axios setup completed');
    },
  },
};
</script>
<style>
main > div {
  padding: 20px;
}
</style>
